import { Box, Heading, Stack, Text } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import type { PortalSourcingEventDetailDto } from "../../../../autogen/bff-api";

interface Props {
  event: PortalSourcingEventDetailDto;
}

const formatInstant = (iso: string): string =>
  new Date(iso).toLocaleString("nb-NO", {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    timeZone: "Europe/Oslo",
  });

export const EventChangeLogSection = ({ event }: Props) => {
  const { t } = useTranslation();
  const changeLog = event.changeLog ?? [];
  if (changeLog.length === 0) return null;

  const newestFirst = [...changeLog].sort((a, b) =>
    (b.publishedAt ?? b.createdAt).localeCompare(a.publishedAt ?? a.createdAt),
  );

  return (
    <Box borderWidth="1px" borderColor="smBorder" borderRadius="xl" bg="white" p="6">
      <Heading as="h3" size="sm" mb="4">
        {t("Changes to the announcement")}
      </Heading>
      <Stack spacing="3">
        {newestFirst.map((revision) => (
          <Box key={revision.id} borderLeftWidth="3px" borderColor="smPrimary" pl="4">
            <Text fontSize="xs" color="smMuted">
              {revision.publishedAt ? formatInstant(revision.publishedAt) : ""}
            </Text>
            <Text fontSize="sm" fontWeight="medium" mt="1">
              {revision.changeDescription}
            </Text>
            {revision.bidSubmissionDeadline && (
              <Text fontSize="sm" color="smMuted" mt="1">
                {t("Bid deadline")}: {formatInstant(revision.bidSubmissionDeadline)}
              </Text>
            )}
          </Box>
        ))}
      </Stack>
    </Box>
  );
};
